console.log('Mariage Julie & Arnaud - Website Ready');

const sections = document.querySelectorAll('section[id], footer[id]');
const navLinks = document.querySelectorAll('nav a[href^="#"]');

const observerOptions = {
  root: null,
  rootMargin: '-20% 0px -60% 0px',
  threshold: 0
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const sectionId = entry.target.getAttribute('id');
      
      navLinks.forEach(link => {
        const linkHref = link.getAttribute('href');
        
        if (linkHref === `#${sectionId}`) {
          link.classList.add('text-orange-900', 'dark:text-orange-100', 'font-bold', 'border-b-2', 'border-orange-800/20', 'pb-1');
          link.classList.remove('text-stone-500', 'dark:text-stone-400', 'font-medium');
        } else {
          link.classList.remove('text-orange-900', 'dark:text-orange-100', 'font-bold', 'border-b-2', 'border-orange-800/20', 'pb-1');
          link.classList.add('text-stone-500', 'dark:text-stone-400', 'font-medium');
        }
      });
    }
  });
}, observerOptions);

sections.forEach(section => {
  observer.observe(section);
});

navLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const targetId = link.getAttribute('href');
    const targetSection = document.querySelector(targetId);
    
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

const brandName = document.getElementById('brand-name');
let clickCount = 0;
let airportModeActive = false;

const counterDiv = document.createElement('div');
counterDiv.id = 'click-counter';
counterDiv.textContent = '0/20';
document.body.appendChild(counterDiv);

brandName.addEventListener('click', () => {
  if (airportModeActive) return;
  
  clickCount++;
  counterDiv.textContent = `${clickCount}/20`;
  counterDiv.classList.add('visible');
  
  if (clickCount >= 20) {
    activateAirportMode();
    clickCount = 0;
    counterDiv.classList.remove('visible');
  }
  
  setTimeout(() => {
    if (clickCount < 20) {
      counterDiv.classList.remove('visible');
    }
  }, 2000);
});

function activateAirportMode() {
  airportModeActive = true;
  
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*+-/=?^_|~ ';
  
  const accueilSection = document.getElementById('accueil');
  const navBar = document.querySelector('nav');
  if (!accueilSection && !navBar) return;
  
  const textNodes = [];
  
  if (navBar) {
    const walkerNav = document.createTreeWalker(
      navBar,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (!node.textContent.trim()) return NodeFilter.FILTER_SKIP;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );
    let node;
    while (node = walkerNav.nextNode()) {
      textNodes.push(node);
    }
  }
  
  if (accueilSection) {
    const walkerAccueil = document.createTreeWalker(
      accueilSection,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (!node.textContent.trim()) return NodeFilter.FILTER_SKIP;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );
    let node;
    while (node = walkerAccueil.nextNode()) {
      textNodes.push(node);
    }
  }
  
  const originalData = [];
  let totalCount = 0;
  let doneCount = 0;
  let maxTime = 0;
  
  textNodes.forEach((textNode) => {
    const parent = textNode.parentElement;
    const original = textNode.textContent;
    const withNbsp = original.replace(/ /g, '\u00A0');
    
    const wrapper = document.createElement('span');
    
    withNbsp.split('').forEach((char, i) => {
      totalCount++;
      const dur = 80 + i * 10;
      const flips = 5 + Math.floor(Math.random() * 10);
      maxTime = Math.max(maxTime, (flips + 1) * dur);
      
      const span = document.createElement('span');
      span.className = 'split-flap-char';
      span.textContent = char;
      wrapper.appendChild(span);
      
      let c = 0;
      const iv = setInterval(() => {
        if (c >= flips) {
          span.textContent = char;
          span.classList.remove('flipping');
          clearInterval(iv);
          doneCount++;
          if (doneCount === totalCount) restore();
          return;
        }
        span.textContent = chars[Math.floor(Math.random() * chars.length)];
        span.classList.add('flipping');
        setTimeout(() => span.classList.remove('flipping'), 50);
        c++;
      }, dur);
    });
    
    originalData.push({ textNode, parent, wrapper, original });
    parent.replaceChild(wrapper, textNode);
  });
  
  function restore() {
    originalData.forEach(d => {
      if (!d.wrapper.parentElement) return;
      const newNode = document.createTextNode(d.original);
      d.wrapper.parentElement.replaceChild(newNode, d.wrapper);
    });
    airportModeActive = false;
  }
  
  setTimeout(() => {
    if (airportModeActive) restore();
  }, maxTime + 500);
}

